import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { ADD } from "../../assets/icons";
import PromotionTable from "./component/PromotionTable";
import PromotionForm from "./component/PromotionForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";

function Promotion() {
  const dispatch = useDispatch();

  const promotions = useSelector((state: RootState) =>
    Object.values(state.promotion)
  );

  const [formVisible, setFormVisible] = useState(false);

  const onOpenForm = () => {
    setFormVisible(true);
  };

  const onCloseForm = () => {
    setFormVisible(false);
  };

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_promotions")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("nouvelle_promotion")}
            leftComponent={
              <SvgContainer svg={ADD} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            onClick={onOpenForm}
          />
        </Stack>
      </Stack>
      <PromotionTable data={promotions} />
      {formVisible ? (
        <PromotionForm open={formVisible} onClose={onCloseForm} />
      ) : null}
    </Box>
  );
}

export default Promotion;
